import { site, asyncFetchGet, asyncFetchPost, asyncFetchDelete } from './global.js';
import moment from 'moment';

export const getHomeworkListByClass = (class_id) => asyncFetchGet('homeworks', `/?belonged_class=${class_id}`)

export const getHomeworkById = (id) => asyncFetchGet('homeworks', `/${id}/`)

export const deleteHomeworkById = (id) => asyncFetchDelete('homeworks', id)

export async function postHomework(name, description, deadline, classId, teacherId, attachment) {
    const formData = new FormData();
    formData.append('name', name);
    formData.append("description", description);
    formData.append(
        "deadline",
        moment(deadline).format("YYYY-MM-DDTHH:mm")
    );
    formData.append("belonged_class", classId);
    formData.append("teacher", teacherId);
    formData.append("attachment", attachment);
    const response = await fetch(site + "homeworks/", {
        method: "POST",
        headers: {
            Authorization: "Token " + localStorage.getItem("token")
        },
        body: formData
    });
    const result = await response.json();
    return result;
}

export async function getHomeworkWithCommentsById(id) {
    const response = await asyncFetchGet('homeworks', `/${id}/`);
    const { name, description, deadline, release_time, teacher_info: teacher, comments, attachment, student_count, answer_count, corrected_answer_count } = response;

    const resolvedComments = comments.map(comment => {
        const { content, child_comments, publish_time, author, id } = comment;
        const replies = child_comments.map(reply => {
            const reply_from = {
                name: reply.from_user_obj.full_name,
                avatar: reply.from_user_obj.avatar
            };
            let reply_to = undefined;
            if (reply.reply_to && reply.to_user_obj) {
                reply_to = {
                    name: reply.to_user_obj.full_name,
                    avatar: reply.to_user_obj.avatar
                };
            }
            return {
                id: reply.id,
                content: reply.content,
                publish_time: moment(reply.publish_time).format("MMM Do, YYYY, HH:mm"),
                from: reply_from,
                to: reply_to
            }
        });

        return {
            id,
            content,
            publish_time: moment(publish_time).format("MMM Do, YYYY, HH:mm"),
            from: {
                name: author.full_name,
                avatar: author.avatar
            },
            replies
        };
    });

    return {
        name,
        description,
        attachment,
        deadline: moment(deadline).format("MMM Do, YYYY, HH:mm"),
        release_time: moment(release_time).format("MMM Do, YYYY, HH:mm"),
        teacher: {
            name: teacher.full_name,
            avatar: teacher.avatar,
        },
        comments: resolvedComments,
        student_count, answer_count, corrected_answer_count
    };
}

export async function postHomeworkComment(content, homeworkId, userId) {
    // content-type: 9 -> homework
    const res = await asyncFetchPost('comments', {
        content_type: 9,
        object_id: homeworkId,
        content,
        author: userId
    });
    return res;
}

export const getAnswerListByHomework = (homework_id) => asyncFetchGet('homework-answers', `/?homework__id=${homework_id}`);

export async function postAnswer(description, attachment, studentId, homeworkId) {
    const formData = new FormData();
    formData.append("description", description);
    formData.append("student", studentId);
    formData.append("homework", homeworkId);
    formData.append("attachment", attachment);
    const response = await fetch(site + "homework-answers/", {
        method: "POST",
        headers: {
            Authorization: "Token " + localStorage.getItem("token")
        },
        body: formData
    });
    const result = await response.json();
    return result;
}

export async function setAnswerScore(answer_id, score){
    const res = await asyncFetchPost(`homework-answers/${answer_id}/set_score/`, {
        score: score
    });
    return res;
}


export const getStudentScore = (homework_id) => asyncFetchGet('homeworks', `/${homework_id}/get_score/`);

export const getAnswerByHomeworkAndStudent = (homework_id, student_id) => asyncFetchGet('homework-answers', `/?homework__id=${homework_id}&student__id=${student_id}`);